
declare var dataLayer: any;
import { Component, Vue } from "vue-property-decorator";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/dist/sweetalert2.min.css";

@Component({})
export default class Activate extends Vue {
  async mounted() {
    try {
      const response = await (this.$root as any)._put(
        `user/activate/${atob(this.$route.params.token.replace("}", ""))}`,
        {}
      );
      this.$store.commit("setToken", response.token);
    } catch (e) {
      if (e.message === "Token expired") {
        return Swal.fire(
          "Token Expirado!",
          "El token ingresado es inválido. Le hemos enviado uno nuevo.",
          "error"
        ).then((result: any) => {
          (window as any).location = "/";
        });
      }
    }
    await (this as any).$root.reloadUser();

    dataLayer.push({
      event: "VirtualPageview",
      virtualPageURL: "/crear-cuenta/estado-activada",
      virtualPageTitle: "Crear Cuenta - Activada",
    });

    Swal.fire(
      "Cuenta Activada!",
      "Se activó correctamente la cuenta.",
      "success"
    ).then((result: any) => {
      (window as any).location = "/crear-cuenta";
    });
  }
}
